// extracted by mini-css-extract-plugin
export var typography = "styles-module--typography--7Ngoo";
export var typographyListTable = "styles-module--typographyListTable--IzzMh";
export var typographyListTableExample = "styles-module--typographyListTableExample---U4qf";
export var typographyListTableRow = "styles-module--typographyListTableRow--h4oIw";